import type { FaireProductEntity } from "../../entity_types/product";

export const p_79h5jysf9h: FaireProductEntity = {
  token: "p_79h5jysf9h",
  type: "product",
  name: "Crack Egg Fidget Squishy Toy For Kids",
  brandToken: "b_h8vd5c4vfp",
  brandName: "Mochi Mob",
  imageUrl:
    "https://cdn.faire.com/fastly/657dff6043841106851e8d67d9f19d002a8a289579a23fe17310c47b3dc3ae34.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/40ffc22614951da6e3390c2b04f50bf6652863698b74e34e8f6c5a72e3870dd2.jpeg",
    "https://cdn.faire.com/fastly/5589b453faca90359910006859036391eca2ea627662e67463f6fcc17b4d952f.jpeg",
  ],
  priceDollars: 7.99,
  description:
    "Fun Cracked Egg Design: Features a playful cracked egg shape that kids will love.\n\nSoft & Thick Squeeze Texture: Provides a satisfying sensory experience with every squeeze.\n\nStress Relief & Relaxation: Helps reduce stress and encourages calming tactile play.\n\nDurable Construction: Made from quality materials for repeated squeezing and long-lasting use.\n\nCompact & Portable: Easy to carry in pockets, backpacks, desk drawers, and travel bags.\n\nScreen-Free Entertainment: Encourages hands-on sensory play at home, school, or while traveling.\n\nPerfect Party Favor: Great for birthdays, classroom rewards, gift bags, and giveaways.\n\nFun Collectible Toy: A unique novelty toy for kids and fidget enthusiasts.",
  tags: [],
  msrpDollars: 17.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:26.259Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
